import { Simulator } from './simulation/simulator.ts';
import { CanvasRenderer } from './rendering/canvas-renderer.ts';
import { Controls } from './ui/controls.ts';
import { initDraggablePanels } from './ui/panels.ts';

export class App {
  private simulator: Simulator;
  private renderer: CanvasRenderer;
  private controls: Controls;

  constructor() {
    const width = 150;
    const height = 100;
    const defaultRule = 'B3/S23';

    this.simulator = new Simulator(width, height, defaultRule);
    this.simulator.randomize(0.3);

    const canvas = document.getElementById('grid-canvas') as HTMLCanvasElement;
    this.renderer = new CanvasRenderer(canvas);
    this.renderer.centerOn(width, height);

    this.controls = new Controls(this.simulator, this.renderer);
    this.controls.init();

    initDraggablePanels();

    this.controls.render();
  }
}
